export function show_sim_balance(sim_in_device, user_id, account) {
    return sim_in_device?.sim_type != 'billed';
    // const is_billed = sim_in_device?.sim_type === 'billed';
    //
    // const is_sim_by_user = account.sims.some((sim) =>
    //     sim_id_equals(sim.sim_card.id, sim_in_device?.sim_id)
    // );
    //
    // const device_by_user = user_id === account.id;
    //
    // return !is_billed || (!is_sim_by_user && device_by_user);
}
